// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"ps_a bik_sn bik_sv bik_sw bik_kx bik_ky bik_ke undefined bik_vt"};